/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NumeroUtileDto } from '../../models/numero-utile-dto';

export interface ApiNumeroUtileNumeroUtileByIdGet$Params {
    /**
     * Id del numero utile da caricare
     */
    numeroUtileId: number;
}

export function apiNumeroUtileNumeroUtileByIdGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiNumeroUtileNumeroUtileByIdGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<NumeroUtileDto>> {
    const rb = new RequestBuilder(rootUrl, apiNumeroUtileNumeroUtileByIdGet.PATH, 'get');
    if (params) {
        rb.query('numeroUtileId', params.numeroUtileId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<NumeroUtileDto>;
        }),
    );
}

apiNumeroUtileNumeroUtileByIdGet.PATH = '/api/numero-utile/numero-utile-by-id';
